import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import PageHeader from "components/common/PageHeader";
import DocumentTitle from "components/common/DocumentTitle";
import UserNotification from "util/UserNotification";
import SectionGrid from "components/common/Section/SectionGrid";
import SectionComponent from "components/common/Section/SectionComponent";
import useHeaderBadge, { useUpdateHeaderBadge } from "customization/header-badge/useHeaderBadge";
import Spinner from "components/common/Spinner";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheck from "license/LicenseCheck";
import WelcomePageConfiguration from "customization/welcome-page/WelcomePageConfiguration";
import useUpdateWelcomePageConfiguration from "customization/welcome-page/useWelcomePage";
import HeaderBadgeConfiguration from "./header-badge/HeaderBadgeConfiguration";
import ThemeEditor from "./theme-editor/ThemeEditor";
import PublicNotifications from "./public-notifications/PublicNotifications";
import EmailTemplateConfiguration from "./email-templates/EmailTemplateConfiguration";
const CustomizationPage = () => {
  const { t } = useTranslation("enterprise_customization");
  const productName = useProductName();
  const { data: badgeConfig, isInitialLoading } = useHeaderBadge();
  const { mutateAsync: _updateHeaderConfiguration } = useUpdateHeaderBadge();
  const updateHeaderConfiguration = useCallback(
    (config) => _updateHeaderConfiguration(config).then(() => {
      UserNotification.success(t("page.update_success"));
    }),
    [_updateHeaderConfiguration, t]
  );
  const { mutateAsync: _updateWelcomePageConfiguration } = useUpdateWelcomePageConfiguration();
  const updateWelcomePageConfiguration = useCallback(
    (config) => _updateWelcomePageConfiguration(config).then(() => {
      UserNotification.success(t("page.update_success"));
    }),
    [_updateWelcomePageConfiguration, t]
  );
  if (isInitialLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(
    LicenseCheck,
    {
      licenseSubject: LICENSE_SUBJECTS.customization,
      title: t("page.license_title"),
      text: t("page.license_text"),
      bsStyle: "danger",
      displayWarningContainer: true,
      hideChildren: true
    },
    /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("page.title") }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("page.title") }, /* @__PURE__ */ React.createElement("span", null, t("page.description", { productName }))), /* @__PURE__ */ React.createElement(SectionGrid, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(SectionComponent, { title: t("page.global_theme") }, /* @__PURE__ */ React.createElement("p", null, t("page.global_theme_hint")), /* @__PURE__ */ React.createElement(ThemeEditor, null)), /* @__PURE__ */ React.createElement(SectionComponent, { title: t("page.welcome_rss") }, /* @__PURE__ */ React.createElement(WelcomePageConfiguration, { updateConfig: updateWelcomePageConfiguration }))), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(SectionComponent, { title: t("page.header_badge") }, /* @__PURE__ */ React.createElement(HeaderBadgeConfiguration, { config: badgeConfig, updateConfig: updateHeaderConfiguration })), /* @__PURE__ */ React.createElement(PublicNotifications, null), /* @__PURE__ */ React.createElement(SectionComponent, { title: t("page.email_templates") }, /* @__PURE__ */ React.createElement(EmailTemplateConfiguration, null))))))
  );
};
export default CustomizationPage;
